// extracted by mini-css-extract-plugin
module.exports = {"PageTop":"Page_PageTop__KGJXv","Title":"Page_Title__Fh6Sb"};